import { Company } from "../company";
import { Langue } from "../langue";
import { ProprieteAffichee, CustomAffichage, TypePropriete } from "../proprieteAffichee";
import { Region } from "../region";
import { Site } from "../site";


export class UtilisateurSite{
    keycloakUserId:string

}

export enum LicenceType {
    None = 'None',
    Free = 'Free',
    Standard= 'Standard',
}

export class UserDtoLight {
    userId: string;
    companyId: number;
    companyName: string;

    organizationIds: number[];

    username = "";
    firstName = "";
    lastName = "";

    email:string;
    emailVerified = false;

    enabled = true;
    licenceType: LicenceType = LicenceType.Standard;

    dateCreation: Date;
    
    langueIsoCode = 'en';
    langueId: number;

    public static getProprietesAffichees() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('enabled', 'USER_KEYCLOAK.ACTIVE','',
        new CustomAffichage(TypePropriete.Boolean, 'fas fa-check-circle checkbox-epc-green', 'fas fa-minus-circle checkbox-epc-red')));

        tab.push(new ProprieteAffichee('username', 'USER_KEYCLOAK.NOM_UTILISATEUR'));
        tab.push(new ProprieteAffichee('firstName', 'USER_KEYCLOAK.PRENOM'));
        tab.push(new ProprieteAffichee('lastName', 'USER_KEYCLOAK.NOM_DE_FAMILLE'));
        tab.push(new ProprieteAffichee('email', 'USER_KEYCLOAK.UTILISATEUR_EMAIL'));
        tab.push(new ProprieteAffichee('keycloakRole', 'REFERENTIEL_UTILISATEUR.ROLE', 'name'));
        //tab.push(new ProprieteAffichee('dateDerniereConnexion', 'LISTE_GENERIQUE.UTILISATEUR_DATE', '', new CustomAffichage(TypePropriete.Date)));

        tab.push(new ProprieteAffichee('companyName', 'GLOBAL.COMPANY'));
        
        tab.push(new ProprieteAffichee('applications', 'REFERENTIEL_UTILISATEUR.APPLICATIONS', '', new CustomAffichage(TypePropriete.String, 'fas fa-desktop', 'fas fa-mobile-alt')));
        return tab;
    }
}

export class KeycloakUtilisateur {
    id: string;
    keycloakUserId: string;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    emailVerified: boolean;
    enabled: boolean;
    langueId: number;
    langue: Langue;
    dateCreation: Date;
    
    regions: Region[];
    sites: Site[];
    currentSite: Site;
    currentRegion: Region;
    keycloakRoleId:string;
    company: Company;
    companyId: number;
    companyName: string;
    applications: string[] = [];

    
    getProprietesAffichees() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('enabled', 'USER_KEYCLOAK.ACTIVE','',
        new CustomAffichage(TypePropriete.Boolean, 'fas fa-check-circle checkbox-epc-green', 'fas fa-minus-circle checkbox-epc-red')));

        tab.push(new ProprieteAffichee('username', 'USER_KEYCLOAK.NOM_UTILISATEUR'));
        tab.push(new ProprieteAffichee('firstName', 'USER_KEYCLOAK.PRENOM'));
        tab.push(new ProprieteAffichee('lastName', 'USER_KEYCLOAK.NOM_DE_FAMILLE'));
        tab.push(new ProprieteAffichee('email', 'USER_KEYCLOAK.UTILISATEUR_EMAIL'));
        tab.push(new ProprieteAffichee('keycloakRole', 'REFERENTIEL_UTILISATEUR.ROLE', 'name'));
        //tab.push(new ProprieteAffichee('dateDerniereConnexion', 'LISTE_GENERIQUE.UTILISATEUR_DATE', '', new CustomAffichage(TypePropriete.Date)));

        tab.push(new ProprieteAffichee('companyName', 'GLOBAL.COMPANY'));
        
        tab.push(new ProprieteAffichee('applications', 'REFERENTIEL_UTILISATEUR.APPLICATIONS', '', new CustomAffichage(TypePropriete.String, 'fas fa-desktop', 'fas fa-mobile-alt')));
        return tab;
    }

    getProprietesAfficheesWithoutRole() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('enabled', 'USER_KEYCLOAK.ACTIVE','',
        new CustomAffichage(TypePropriete.Boolean, 'fas fa-check-circle checkbox-epc-green', 'fas fa-minus-circle checkbox-epc-red')));

        tab.push(new ProprieteAffichee('username', 'USER_KEYCLOAK.NOM_UTILISATEUR'));
        tab.push(new ProprieteAffichee('firstName', 'USER_KEYCLOAK.PRENOM'));
        tab.push(new ProprieteAffichee('lastName', 'USER_KEYCLOAK.NOM_DE_FAMILLE'));
        tab.push(new ProprieteAffichee('email', 'USER_KEYCLOAK.UTILISATEUR_EMAIL'));
        //tab.push(new ProprieteAffichee('keycloakRole', 'REFERENTIEL_UTILISATEUR.ROLE', 'name'));
        //tab.push(new ProprieteAffichee('dateDerniereConnexion', 'LISTE_GENERIQUE.UTILISATEUR_DATE', '', new CustomAffichage(TypePropriete.Date)));
   
        return tab;
    }

    getLightProprietesAffichees() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('enabled', 'USER_KEYCLOAK.ACTIVE','',
        new CustomAffichage(TypePropriete.Boolean, 'fas fa-check-circle checkbox-epc-green', 'fas fa-minus-circle checkbox-epc-red')));
        
        tab.push(new ProprieteAffichee('username', 'USER_KEYCLOAK.NOM_UTILISATEUR'));
        tab.push(new ProprieteAffichee('firstName', 'USER_KEYCLOAK.PRENOM'));
        tab.push(new ProprieteAffichee('lastName', 'USER_KEYCLOAK.NOM_DE_FAMILLE'));
        tab.push(new ProprieteAffichee('email', 'USER_KEYCLOAK.UTILISATEUR_EMAIL'));
        tab.push(new ProprieteAffichee('keycloakRole', 'REFERENTIEL_UTILISATEUR.ROLE', 'name'));
        //tab.push(new ProprieteAffichee('dateDerniereConnexion', 'LISTE_GENERIQUE.UTILISATEUR_DATE', '', new CustomAffichage(TypePropriete.Date)));

      return tab;
    }
}